import { render } from "./checkPositionCont.vue?vue&type=template&id=6c086793&scoped=true&ts=true"
import script from "./checkPositionCont.vue?vue&type=script&lang=ts"
export * from "./checkPositionCont.vue?vue&type=script&lang=ts"

import "./checkPositionCont.vue?vue&type=style&index=0&id=6c086793&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c086793"]])

export default __exports__